import React from "react";
import "./index.css";
const Footer = props => {
  return /*#__PURE__*/React.createElement("footer", {
    id: "footer",
    className: "footer"
  }, props.children);
};
export default Footer;